import { render, staticRenderFns } from "./ProfileRenderer.vue?vue&type=template&id=1a507144&scoped=true&"
import script from "./ProfileRenderer.vue?vue&type=script&lang=js&"
export * from "./ProfileRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a507144",
  null
  
)

export default component.exports